import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

import { AdviserRow } from '../brokerCRConfig';

type AdvisersCRProps = { tableProps: TableProps<AdviserRow> };

export const AdvisersCR = ({ tableProps }: AdvisersCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
